export enum Key {
  CLASSROOM_NAME = "classroomName",
  CLASSROOM_ID = "classroomId",
  LESSON_NAME = "lessonName",
  LESSON_ID = "lessonId",
  STUDENT_NAME = "studentName",
  ASSIGN_DATE = "assignDate",
  LAST_LEARNED = "lastLearned",
  TIME_SPENT = "timeSpent",
  BITES = "bites",
  GOALS = "goals",
  EXIT_TICKET = "exitTicket",
  PRE_ASSESSMENT = "preAssessment",
  CUSTOM_TICKET = "customTicket",
  LESSON_STATUS = "lessonStatus",
}

export enum OverviewKey {
  TOTAL_STUDENTS = "totalStudents",
  LESSONS_STARTED = "lessonsStarted",
  LESSONS_COMPLETED = "lessonsCompleted",
  AVERAGE_TIME_SPENT = "averageTimeSpent",
  COMPLETION_RATE = "completionRate",
}

export enum LessonStatus {
  COMPLETED = "completed",
  STARTED = "started",
  NOT_STARTED = "not_started",
}
